/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateOrgWorkspaceMembershipSchema
 */
export interface UpdateOrgWorkspaceMembershipSchema {
    /**
     * 
     * @type {number}
     * @memberof UpdateOrgWorkspaceMembershipSchema
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrgWorkspaceMembershipSchema
     */
    isAdmin: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrgWorkspaceMembershipSchema
     */
    creditLimit: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrgWorkspaceMembershipSchema
     */
    coreLimit: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOrgWorkspaceMembershipSchema
     */
    workspaceId: number;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateOrgWorkspaceMembershipSchema
     */
    access: boolean;
}

/**
 * Check if a given object implements the UpdateOrgWorkspaceMembershipSchema interface.
 */
export function instanceOfUpdateOrgWorkspaceMembershipSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "isAdmin" in value;
    isInstance = isInstance && "creditLimit" in value;
    isInstance = isInstance && "coreLimit" in value;
    isInstance = isInstance && "workspaceId" in value;
    isInstance = isInstance && "access" in value;

    return isInstance;
}

export function UpdateOrgWorkspaceMembershipSchemaFromJSON(json: any): UpdateOrgWorkspaceMembershipSchema {
    return UpdateOrgWorkspaceMembershipSchemaFromJSONTyped(json, false);
}

export function UpdateOrgWorkspaceMembershipSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOrgWorkspaceMembershipSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'isAdmin': json['is_admin'],
        'creditLimit': json['credit_limit'],
        'coreLimit': json['core_limit'],
        'workspaceId': json['workspace_id'],
        'access': json['access'],
    };
}

export function UpdateOrgWorkspaceMembershipSchemaToJSON(value?: UpdateOrgWorkspaceMembershipSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'is_admin': value.isAdmin,
        'credit_limit': value.creditLimit,
        'core_limit': value.coreLimit,
        'workspace_id': value.workspaceId,
        'access': value.access,
    };
}

